import { createContext, Dispatch, SetStateAction } from 'react';

import { noop } from '@/utils/noop';

export type ManagementContextProps = {
  initialized: boolean;
  title: string;
  setTitle?: Dispatch<SetStateAction<string>>;
  subtitle: string | JSX.Element;
  setSubtitle?: Dispatch<SetStateAction<string | JSX.Element>>;
  lastActive: string;
  setLastActive?: Dispatch<SetStateAction<string>>;
  joined?: string;
  setJoined?: Dispatch<SetStateAction<string>>;
  hasSubHeading?: boolean;
  setHasSubHeading?: Dispatch<SetStateAction<boolean>>;
  loading?: boolean;
  setLoading?: Dispatch<SetStateAction<boolean>>;
  hasSubtitle?: boolean;
  setHasSubtitle?: Dispatch<SetStateAction<boolean>>;
};

export const ManagementContext = createContext<ManagementContextProps>({
  initialized: false,
  title: '',
  setTitle: noop,
  subtitle: '',
  setSubtitle: noop,
  lastActive: '',
  setLastActive: noop,
  joined: '',
  setJoined: noop,
  hasSubHeading: false,
  setHasSubHeading: noop,
  loading: true,
  setLoading: noop,
  hasSubtitle: false,
  setHasSubtitle: noop,
});
